import styled from 'styled-components';
import type { FlattenSimpleInterpolation } from 'styled-components';

interface StyledFlexProps {
    $layoutCss?: Array<FlattenSimpleInterpolation | string>;
}

export const StyledFlex = styled.div<StyledFlexProps>`
    box-sizing: border-box;
    ${({ $layoutCss }) => $layoutCss}
`;
